import React, { memo, useMemo } from 'react';

const BenefitsList = ({ items, title }) => {
  const renderedBenefits = useMemo(
    () =>
      items.map((item) => (
        <div className='benefits-list__item' key={item}>
          <span className='benefits-list__item-check'></span>
          <span>{item}</span>
        </div>
      )),
    [items]
  );

  return (
    <div className='benefits-list'>
      {title && <h6 className='benefits-list__title'>{title}</h6>}
      <div className='benefits-list__items'>{renderedBenefits}</div>
    </div>
  );
};

export default memo(BenefitsList);
